import { FC } from 'react';
import {
  GoogleReCaptcha,
  GoogleReCaptchaProvider,
} from 'react-google-recaptcha-v3';

interface CaptchaProps {
  siteKey: string;
  onChange: (value: string | null) => void;
}

const Captcha: FC<CaptchaProps> = ({ siteKey, onChange }) => (
  <GoogleReCaptchaProvider reCaptchaKey={siteKey}>
    <GoogleReCaptcha onVerify={onChange} />
  </GoogleReCaptchaProvider>
);

export default Captcha;
